import React from 'react';
import styled from '@emotion/styled';
import { mq } from 'style/variables';

type DlProps = {
  title: string;
  data: string;
};

const Container = styled.dl`
  display: flex;
  font-size: 14px;
  font-weight: 400;
  & + & {
    margin-top: 5px;
  }
`;

const Title = styled.dt`
  position: relative;
  margin-right: 26px;
  flex-shrink: 0;
  ${mq.onlysp} {
    margin-right: 5px;
    padding-right: 5px;
  }
  &::after {
    content: ':';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    color: #c5c5c5;
  }
`;

const Data = styled.dd``;

export const Dl: React.FC<DlProps> = props => {
  return (
    <Container>
      <Title>{props.title}</Title>
      <Data>{props.data}</Data>
    </Container>
  );
};
